var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('v-img',{key:_vm.icon,staticClass:"icon",style:({ 
    margin: _vm.margin,
    height: _vm.height,
    width: _vm.width
  }),attrs:{"src":_vm.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }